import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import { KmuModelPage } from "../../kmuModels/KmuModelPage";
import { OptionsPage } from "../../options/OptionsPage";

export const ManipulatorsPage: FC = () => {
  return (
    <div className="">
      <Routes>
        <Route
          path="/kmu-models/*"
          element={<KmuModelPage vehicleCategoryId={1} />}
        />
        <Route
          path="/options/*"
          element={<OptionsPage vehicleCategoryId={1} />}
        />
      </Routes>
    </div>
  );
};
